import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import Login from '../pages/LoginPage';
import Registration from '../pages/RegistrationPage';
import Dashboard from '../pages/Dashboard';
import LicenseGeneration from '../pages/LicenseGenerationCompass';
import Client from '../pages/ClientPage';
import Partner from '../pages/PartnerPage';
import Ran from '../pages/Ran';
import FinalLicenseGeneration from '../pages/FinalLicenseGeneration';
import Downloads from '../pages/DownloadsPage';
import SettingsPage from '../pages/SettingsPage';

const AppRoutes = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
        }
      />
      <Route
        path="/register"
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <Registration />
        }
      />

      <Route
        path="/dashboard"
        element={
          isAuthenticated
            ? <Dashboard />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/licenseGeneration"
        element={
          isAuthenticated
            ? <LicenseGeneration />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/client"
        element={
          isAuthenticated
            ? <Client />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/partner"
        element={
          isAuthenticated
            ? <Partner />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/ran"
        element={
          isAuthenticated
            ? <Ran />
            : <Navigate to="/login" replace />
        }
      />


      <Route
        path="/finalLicenseGeneration"
        element={
          isAuthenticated
            ? <FinalLicenseGeneration />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/downloads"
        element={
          isAuthenticated
            ? <Downloads />
            : <Navigate to="/login" replace />
        }
      />

      <Route
        path="/settings"
        element={
          isAuthenticated
            ? <SettingsPage />
            : <Navigate to="/login" replace />
        }
      />

      {/* Catch all route */}
      <Route
        path="*"
        element={
          isAuthenticated ?
            <Navigate to="/dashboard" replace /> :
            <Navigate to="/login" replace />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
